import React, { useEffect, useState, useRef } from "react";
import { io, Socket } from "socket.io-client";
import Peer from "simple-peer";
import Room from "./Room";
import Chat from "./Chat";
import { logger } from "@/lib/default-logger";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { useUserContext } from "@/context/UserContext";

export default function LiveClassComponent({ resource }) {
  const user = useUserContext();
  const [users, setUsers] = useState<any[]>([]);
  const [socket, setSocket] = useState<Socket | null>(null);
  const socketRef = useRef<any>();

  useEffect(() => {
    logger.log("test");

    socketRef.current = io(process.env.REACT_APP_SERVER_URL + "/chat", {
      autoConnect: true,
      transports: ["websocket"],
      withCredentials: true,
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 5000,
    });
    setSocket(socketRef.current);
    logger.log("socket", socketRef.current);
    // Odaya yalnızca bir kez katılmayı sağlamak için kontrol
    socketRef.current.on("connect", () => {
      logger.log("userJoined", socketRef.current.id);
      if (resource._id) {
        socketRef.current.emit("joinRoom", {
          roomName: resource._id,
          socketId: socketRef.current.id,
          user,
        });
      }
    });

    socketRef.current.on("disconnect", () => {
      logger.log("userLeft", socketRef.current.id);
      socketRef.current.emit("leaveRoom", {
        roomName: resource._id,
        socketId: socketRef.current.id,
        user,
      });
    });

    socketRef.current.on("close", () => {
      logger.log(socketRef.current.id);
      logger.log("Bağlantı kesildi");
    });

    socketRef.current.on("userLeft", (leavingUser) => {
      logger.log("userLeft event triggered:", leavingUser);
      if (leavingUser) {
        setUsers((prevUsers) =>
          prevUsers.filter((u) => u.id !== leavingUser?.id)
        );
      } else {
        logger.warn("userLeft event triggered but leavingUser is undefined");
      }
    });

    return () => {
      socketRef.current.disconnect();
      if (socketRef.current.readyState === 1) {
        socketRef.current?.close();
      }
    };
  }, [resource._id, user]);

  function createPeer(userToSignal, callerID, stream) {
    const peer = new Peer({
      initiator: true,
      trickle: false,
      stream,
    });

    peer.on("signal", (signal) => {
      socketRef.current.emit("sendingSignal", {
        userToSignal,
        callerID,
        signal,
      });
    });

    return peer;
  }

  function addPeer(incomingSignal, callerID, stream) {
    const peer = new Peer({
      initiator: false,
      trickle: false,
      stream,
    });

    peer.on("signal", (signal) => {
      logger.log("returningSignal to ", callerID);
      socketRef.current.emit("returningSignal", { signal, callerID });
    });

    peer.signal(incomingSignal);

    return peer;
  }

  return (
    <div className="md:flex grid grid-cols-1 gap-4 w-full">
      <div className="md:w-3/4 w-full">
        <Room resource={resource} />
      </div>
      {socketRef?.current?.connected}
      {socketRef?.current?.connected ? (
        <div className="md:w-1/4 w-full">
          <Chat
            user={user}
            currentCourse={resource}
            socket={socket}
            users={users}
          />
        </div>
      ) : (
        <div className="md:w-1/4 w-full">
          <div className="w-full h-full flex flex-col items-center justify-center">
            <FontAwesomeIcon icon={faSpinner} spin />
            <span>sohpete bağlanıyor...</span>
          </div>
        </div>
      )}
    </div>
  );
}
